import { FetchGetId, useFetchGetId } from './fetch';
import { FetchResponse } from '../types';
import { Activity } from '../types/activities';

export const useGetReportActivities = (): FetchGetId<FetchResponse<Activity>> =>
  useFetchGetId('activities', '', { autoStart: false, startStateLoading: false, multiple: 'activities' });
